import moment from 'moment'
let phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

export default {
  getConsumerData (VueApp, conId, callback) {
    VueApp.$sdk.get('/consumer/' + conId, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        
        let conData = {
          id: res.ID,
          firstName: res.firstName,
          lastName: res.lastName,
          email: res.email,
          mobile: res.countryCode + '' + res.phone,
          enabled: res.enabled === 1,
          deviceOS: '',
          deviceModel: '',
          customerURL: res.customerURL,
          created: moment(res.created, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY'),
          referralCode: res.referralCode,
          wheelChair: res.ada.wheelChairLift,
          serviceDog: res.ada.serviceDog,
          phone: res.phone,
          countryCode: res.countryCode,
          nationalNumber: res.nationalNumber || res.phone,
          // nationalNumber: phone ? mobile.getNationalNumber() : ''
          bday: res.dateOfBirth,
          country: res.userCountry,
          passportNum: res.passportNum
        }
        let phone = String(res.phone)
        if (phone.lastIndexOf('+') > -1) {
          phone = phone.substring(phone.lastIndexOf('+') + 1)
          conData.phone = phone
          if (conData.nationalNumber == 'undefined') conData.nationalNumber = phone
          let mobile = phoneUtil.parse('+' + phone, '')
          conData.countryCode = mobile.getCountryCode()
        }

        VueApp.$sdk.get('/consumer/' + conId + '/phones', {
          token: VueApp.$store.state.session.sessionToken
        }, res2 => {
          if (!res.error) {
            conData.deviceOS = res2.OS
            conData.deviceModel = res2.model
          }
          VueApp.$store.commit('consumer/setuserInfo', conData)
          callback(res)
        })
      } else {
        callback(res)
      }
    })
  },
  updateConsumer (VueApp, data, callback) {
    let self = this
    // let mobile = phoneUtil.parse('+' + data.mobile, '')
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/consumer/' + data.id, data, res => {
      if (!res.error) {
        let phoneData = {
          id: data.id,
          // mobile: mobile.getNationalNumber(),
          // countryCode: mobile.getCountryCode(),
          mobile: data.phone,
          countryCode: data.countryCode,
          deviceOS: data.deviceOS,
          deviceModel: data.deviceModel,
          nationalNumber: data.nationalNumber
        }
        self.updatePhone(VueApp, phoneData, function (res2) {
          callback(res2)
        })
      } else {
        callback(res)
      }
    })
  },
  updatePhone (VueApp, data, callback) {
    VueApp.$sdk.post('/consumer/' + data.id + '/phones', {
      token: VueApp.$store.state.session.sessionToken,
      phoneNumber: data.mobile,
      countryCode: data.countryCode,
      'OS': data.deviceOS,
      model: data.deviceModel,
      type: 'C',
      nationalNumber: data.nationalNumber
    }, res => {
      callback(res)
    })
  },
  emailPassword (VueApp, conId, callback) {
    VueApp.$sdk.delete('/consumer/' + conId + '/password', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  updateConsumerStatus (VueApp, data, callback) {
    let action = data.isActive ? 'post' : 'delete'
    VueApp.$sdk[action]('/provider/' + data.id + '/active', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/user-info.js